import { useState } from "react"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { quoteFormSchema, QuoteFormData } from "@/lib/validations/quote-form"

export function useLeadForm() {
  const [isSubmitted, setIsSubmitted] = useState(false)
  const [submitError, setSubmitError] = useState<string | null>(null)

  const form = useForm<QuoteFormData>({
    resolver: zodResolver(quoteFormSchema),
    mode: "onBlur",
    defaultValues: {
      name: "",
      email: "",
      phone: "",
      from: "",
      to: "",
      moveType: "household",
      moveDate: undefined,
      inventory: [],
      message: "",
    },
  })

  const onSubmit = async (data: QuoteFormData) => {
    setSubmitError(null)
    
    try {
      const response = await fetch('/api/leads', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...data,
          moveDate: data.moveDate?.toISOString(),
        }),
      })

      const result = await response.json()

      if (!response.ok) {
        throw new Error(result.error || 'Failed to submit form')
      }

      setIsSubmitted(true)
      
      // Redirect to WhatsApp after 1.5 seconds
      setTimeout(() => {
        window.open(result.whatsappUrl, "_blank")
      }, 1500)
    } catch (error) {
      console.error('Error submitting lead:', error)
      setSubmitError(
        error instanceof Error
          ? error.message
          : 'An error occurred. Please try again.'
      )
    }
  }

  return {
    form,
    isSubmitted,
    submitError,
    onSubmit,
  }
}
